import { safeExternalUrl } from '../config/navigation.js'

// 后台可配置站内素材；拒绝跨协议、协议相对地址和反斜线跳转。
export function activityUrl(value) {
  const path = typeof value === 'string' ? value.trim() : ''
  return /^\/(?![\/\\])/.test(path) && !path.includes('\\') ? path : safeExternalUrl(path)
}

// 列表只展示后台公开字段，不从模板名或富文本推造奖励。
export function activityPeriod(activity) {
  if (Number(activity.periodType) === 2) return '长期活动'
  const date = value => Number(value)>0 ? new Intl.DateTimeFormat('zh-CN',{timeZone:'Asia/Shanghai',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date(Number(value)*1000)).replaceAll('/','-') : ''
  const start=date(activity.startAt),end=date(activity.endAt)
  return start && end ? `${start} 至 ${end}` : '活动时间详见规则'
}
export function activitySubtitle(activity) {
  return String(activity.cardSubtitle || activity.description || '').replace(/<[^>]*>/g,'').replace(/&nbsp;/g,' ').replace(/&amp;/g,'&').replace(/\s+/g,' ').trim()
}

// 历史配置缺少金额时展示配置状态，避免出现“固定奖励 元”。
export function activityRuleDetail(value) {
  return String(value || '').replace(/固定奖励\s+元/g, '奖励金额待配置')
}
